import React from "react";
import Navbar from "../Navbar/Navbar";
import Bola from "../Bola";
import Footer from "../Footer/Footer";
import { Link, useParams } from "react-router-dom";
// import DetailProfessiogrammaFilter from "./DetailProfessiogrammaFilter";
import axios from "axios";
import { baseURL } from "../Config/Config";

export default function DetailProfessiogramma() {
  const [detailProf, setDetailProf] = React.useState();
  let { id } = useParams();

  React.useEffect(() => {
    axios
      .get(`${baseURL}professiogramma/professiogramma-list/${id}/`)
      .then((response) => {
        setDetailProf(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  if (!detailProf) return null;
  return (
    <div>
      <Navbar />
      <Bola />
      <div className="container video_name">
        <h1 className="home_name">Professiogrammalar</h1>
      </div>
      <div className="container">
        <div className="video-top">
          <div className="left">
            <Link to="/professiogramma" className="left-material">
              <div className="next">
                <svg
                  width="19"
                  height="16"
                  viewBox="0 0 19 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.9999 6.99997H4.41394L9.70694 1.70697L8.29294 0.292969L0.585938 7.99997L8.29294 15.707L9.70694 14.293L4.41394 8.99997H18.9999V6.99997Z"
                    fill="#4ECB71"
                  />
                </svg>
                <span> Ortga qaytish</span>
              </div>
            </Link>
          </div>
        </div>

        <h2 className="id-name">
          {detailProf.code} - {detailProf.title}
        </h2>
        <div className="professiogramma-box">
          <div className="professiogramma-box_img">
            <img src={detailProf.photo} alt="rasm" />
          </div>

          {/* <DetailProfessiogrammaFilter /> */}
        </div>
      </div>

      <Footer />
    </div>
  );
}
